import BelltowerBrowseCard from "@pathwright/web/src/modules/belltower/BelltowerBrowseCard"
import BelltowerLicenseCard from "@pathwright/web/src/modules/belltower/BelltowerLicenseCard"
import BelltowerResourceCard from "@pathwright/web/src/modules/belltower/BelltowerResourceCard"
import Dashboard from "@pathwright/web/src/modules/home/Dashboard"
import { createCardRoutes } from "lib/core/routing/card-routing"
import { getDefaultLaunchedFromHome } from "../../lib/core/routing/utils"

const cardRoutes = {
  store: {
    path: "store/:schoolId(\\d+)/",
    component: ({ card, match }) => {
      const { schoolId } = match.params
      return (
        <BelltowerBrowseCard
          card={card}
          schoolId={parseInt(schoolId, 10)}
          browseTo={(resource) => `/library/store/${schoolId}/${resource.id}/`}
        />
      )
    },
    getDefaultLaunchedFrom: getDefaultLaunchedFromHome,
    childCards: {
      curriculum: {
        path: ":resourceId(\\d+)/",
        component: ({ card, match }) => {
          const { schoolId, resourceId } = match.params
          return (
            <BelltowerResourceCard
              card={card}
              id={parseInt(resourceId, 10)}
              schoolId={parseInt(schoolId, 10)}
              browseTo={(resource) =>
                `/library/store/${schoolId}/${resource.id}/`
              }
              onLicense={(licenseOffering) =>
                window.App.navigate(
                  `/library/store/${schoolId}/${resourceId}/${licenseOffering.id}/`
                )
              }
              curriculum_licensee_subs={window.App.getStore("school")
                .get("school")
                .get("curriculum_licensee_subs")}
            />
          )
        },
        childCards: {
          license: {
            path: ":licenseOfferingId(\\d+)/",
            component: ({ card, match }) => {
              const { schoolId, resourceId, licenseOfferingId } = match.params
              return (
                <BelltowerLicenseCard
                  card={card}
                  id={parseInt(licenseOfferingId, 10)}
                  schoolId={parseInt(parseInt(schoolId, 10))}
                  // onLicenseSuccess={() =>
                  //   window.App.navigate(
                  //     `/library/store/${schoolId}/${resourceId}/`,
                  //   )
                  // }
                />
              )
            }
          }
        }
      }
    }
  }
}

export default createCardRoutes("/library/", cardRoutes, Dashboard)
